import { getFunctions, httpsCallable } from 'firebase/functions';
import { ENV } from '@configs/env';
import { getFirebaseApp } from './firebase/app';

async function uploadToCloudinary({ file, folder }) {
    const cloudName = ENV.CLOUDINARY?.cloudName;
    const uploadPreset = ENV.CLOUDINARY?.uploadPreset;
    if (!cloudName || !uploadPreset) {
        throw new Error('Cloudinary is not configured. Set VITE_CLOUDINARY_CLOUD_NAME and VITE_CLOUDINARY_UPLOAD_PRESET.');
    }

    const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
    const body = new FormData();
    body.append('file', file);
    body.append('upload_preset', uploadPreset);
    if (folder) body.append('folder', folder);

    const res = await fetch(url, { method: 'POST', body });
    let json = null;
    try {
        json = await res.json();
    } catch {
        json = null;
    }
    if (!res.ok) {
        // Helpful debugging info (Cloudinary returns `error.message` + optional context)
        // Keep in console so you can see exact reason for HTTP 400.
        console.error('Cloudinary upload error payload:', json);
        const msg =
            json?.error?.message ||
            `Cloudinary upload failed (HTTP ${res.status}). Check that your upload preset is UNSIGNED and allows image uploads.`;
        throw new Error(msg);
    }
    return { secureUrl: json.secure_url, publicId: json.public_id };
}

async function deleteCloudinaryAsset(publicId) {
    if (!publicId) return;
    const fnName = ENV.CLOUDINARY?.deleteFunctionName;
    if (!fnName) {
        // No backend configured: we cannot securely delete from the client.
        return;
    }
    const callable = httpsCallable(getFunctions(getFirebaseApp()), fnName);
    await callable({ publicId });
}

/**
 * Replace an image in Cloudinary: delete old publicId first, then upload new.
 */
export async function replaceCloudinaryImage({ file, folder, previousPublicId }) {
    if (!file) throw new Error('Missing file');
    if (previousPublicId) {
        await deleteCloudinaryAsset(previousPublicId);
    }
    return await uploadToCloudinary({ file, folder });
}

